<template>
  <div id="IndexTemisCivil_div">

    <MenuSuperior titulo="DH" subtitulo="Herramienta para Conteo de Días Hábiles"></MenuSuperior>
    <MenuIzquierda></MenuIzquierda>

    <div class="content-area">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>  

    <!--<main class="content-area">

    <div id="title">
      <slot name="title" />
    </div>
    <slot name="main" />
  </main>-->
  </div>
</template>
<script>
  import MenuSuperior from '@/components/Comunes/MenuSuperior.vue'
  import MenuIzquierda from '@/components/DiasHabiles/Comun/MenuIzquierda.vue'

  export default {
    name: `Plantilla`,
    components: {
      MenuSuperior,
      MenuIzquierda
    }
  }
</script>


<style scoped>
  #title {
    padding-bottom: 20px;
  }

    #title h2 {
      font-size: 22px;
    }
</style>



// WEBPACK FOOTER //
// src/components/DiasHabiles/Comun/Plantilla.vue